import React from "react";
import { Check, Clock } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { Eyebrow, Section, SectionTitle } from "@/components/ui-kit/Kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

export const BenefitGrid = ({ withHeading = true }) => {
  const { t } = useI18n();
  const b = t("home.benefits");

  return (
    <>
      {withHeading && (
        <Reveal>
          <Eyebrow>{b.eyebrow}</Eyebrow>
          <SectionTitle className="mt-6 max-w-[20ch]">{b.title}</SectionTitle>
        </Reveal>
      )}
      <Stagger className="mt-14 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-3" step={0.045}>
        {(b.items || []).map((it, i) => (
          <StaggerItem key={it.title} className="bg-white">
            <div className="flex h-full items-start gap-4 p-7" data-testid={`benefit-${i + 1}`}>
              {it.live ? (
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-grn" strokeWidth={2.5} />
              ) : (
                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2} />
              )}
              <div>
                <h3 className="font-display text-base font-semibold text-navy">{it.title}</h3>
                {!it.live && (
                  <span className="mt-2 inline-block border border-gold/50 bg-gold/10 px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.2em] text-gold">
                    {t("common.comingSoon")}
                  </span>
                )}
              </div>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </>
  );
};

export const BenefitsSection = () => (
  <Section className="py-24 sm:py-32" data-testid="benefits-section">
    <BenefitGrid />
  </Section>
);
